import { Link } from 'react-router-dom';
import { popularComics } from '@/mocks/homeData';
import { useInView } from '@/hooks/useInView';

export default function PopularSection() {
  const { ref, isInView } = useInView();

  return (
    <section id="popular" className="py-16 md:py-20 bg-background-50">
      <div
        ref={ref}
        className={`px-4 md:px-6 transition-all duration-700 ${
          isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-fire-line mr-1"></i>人气推荐
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading">
              热门韩国漫画
            </h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
              精选全网人气最高的<strong>韩国漫画</strong>，每一部都值得一读
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {popularComics.map((comic, index) => (
              <Link
                key={comic.id}
                to="/category/all"
                className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`${comic.title} - 韩漫在线免费韩国漫画`}
                  />
                  <div className="absolute top-3 left-3">
                    <span className={`px-2.5 py-1 rounded-full text-xs font-semibold text-background-50 ${
                      comic.tagColor === 'accent' ? 'bg-accent-500' : 'bg-primary-500'
                    }`}>
                      {comic.tag}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3 bg-background-950/70 backdrop-blur-sm rounded-lg px-2 py-1 text-xs text-background-50 font-medium flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {comic.rating}
                  </div>
                </div>

                <div className="p-5">
                  <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors font-heading">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">
                    {comic.author} · {comic.category}
                  </p>
                  <p className="text-xs text-foreground-600 mt-3 line-clamp-2 leading-relaxed">
                    {comic.description}
                  </p>
                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/50">
                    <span className="text-xs text-primary-600 font-medium">
                      {comic.latestChapter}
                    </span>
                    <span className="text-xs text-foreground-500 flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {comic.views}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}